import { Field, connect } from 'formik'
import CountryList from 'i18n-iso-countries'
import de from 'i18n-iso-countries/langs/de.json'
import en from 'i18n-iso-countries/langs/en.json'
import React, { useCallback } from 'react'
import { AddressFieldsOuterProps, AddressFieldsValues } from './types'
import { FormGroup } from 'src/shared'
CountryList.registerLocale(de)
CountryList.registerLocale(en)
const NUMERIC_ZIP_COUNTRY_CODES = [
  'RU',
  'DE',
  'TR',
  'FR',
  'IT',
  'ES',
  'PL',
  'RO',
  'BE',
  'GR',
  'CZ',
  'PT',
  'HU',
  'CH',
  'BG',
  'RS',
  'DK',
  'FI',
  'SK',
  'NO',
]

export const AddressFields: React.ComponentType<AddressFieldsOuterProps> = connect<
  AddressFieldsOuterProps,
  AddressFieldsValues
>(({ formik, required }) => {
  const countries = CountryList.getNames(i18n.locale)
  const countryOptions = Object.keys(countries).map((alpha2) => (
    <option value={alpha2} key={alpha2}>
      {countries[alpha2]}
    </option>
  ))
  const numericZip = NUMERIC_ZIP_COUNTRY_CODES.includes(formik.values.country_alpha2)
  const buildLabel = useCallback((name) => `${i18n.t(`donate.attributes.${name}`)}${required ? '*' : ''}`, [required])

  return (
    <div className="flex flex-wrap">
      <Field
        placeholder={buildLabel('street')}
        label={buildLabel('street')}
        name="street"
        component={FormGroup}
        labelClass="sr-only"
        groupClass="w-full"
      />

      <Field
        name="zip"
        placeholder={buildLabel('zip')}
        label={buildLabel('zip')}
        component={FormGroup}
        groupClass="w-1/3 desktop:w-1/4 pr-2 inline-block"
        labelClass="sr-only"
        type="text"
        pattern={numericZip ? '[0-9]*' : null}
        inputMode={numericZip ? 'tel' : 'text'}
      />

      <Field
        name="city"
        labelClass="sr-only"
        groupClass="w-2/3 desktop:w-5/12 inline-block"
        placeholder={buildLabel('city')}
        label={buildLabel('city')}
        component={FormGroup}
      />

      <div className="form-group desktop:w-1/3 desktop:pl-2 inline-block">
        <label className="control-label sr-only" htmlFor="country_alpha2">
          {buildLabel('country')}
        </label>
        <Field
          component="select"
          className="form-control"
          aria-required="true"
          name="country_alpha2"
          id="country_alpha2"
        >
          {countryOptions}
        </Field>
      </div>
    </div>
  )
})
